/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Mobile Safari only evaluates :active while a touch listener is registered on
// the document, so press feedback on buttons is otherwise dead on iOS.
export const onClientEntry = () => {
  document.addEventListener('touchstart', () => {}, { passive: true });
};
